import { Card, Col, Row } from 'react-bootstrap';
import { maxResultPerFilter } from '../../../../constants/globals';
import CustomButton from '../../CustomButton';
import CustomSelect from '../../CustomSelect';
import { Tooltip } from '@mui/material';

const AttributeCardFooter = (props) => {
  const {
    Placeholders,
    maxResultFilter,
    onChangeMaxResultFilterHandler,
    sendSearchFilters,
  } = props || {};

  return (
    <Card.Footer className={'card-footer w-100'}>
      <Row>
        <Col md={4}>
          <Tooltip
            title={Placeholders.numberOfResults}
            arrow={true}
            placement="bottom"
          >
            <div className="w-100">
              <CustomSelect
                id={'numberOfResults'}
                name={'numberOfResults'}
                label={Placeholders.numberOfResults}
                data={maxResultPerFilter}
                textExtractor={(a) => Placeholders[a]}
                valueExtractor={(a) => a}
                value={maxResultFilter}
                onChange={onChangeMaxResultFilterHandler}
                size={'small'}
                className={`font-size-14`}
              />
            </div>
          </Tooltip>
        </Col>
        <Col md={8} className="search-button">
          <CustomButton
            label={Placeholders.search}
            className={'btn-height default-btn-info float-right'}
            startIcon={<i className="fa-solid fa-magnifying-glass" />}
            onClick={sendSearchFilters}
            type="button"
          />
        </Col>
      </Row>
    </Card.Footer>
  );
};

export default AttributeCardFooter;
